<template>
  <div class="search-filter-holder">
    <div class="columns is-gapless is-mobile">
      <div :class="`is-${gridSize} column is-offset-${gridOffset}`">
        <form class="form" method="post" @submit.prevent="doSubmit">
            <fieldset :disabled="busy">
                <div class="field has-addons">
                  <div class="control is-fullwidth">
                    <label class="is-sr-only" :for="`search-filter-${HTMLId}`">Search by title or topic</label>
                    <input
                      :id="`search-filter-${HTMLId}`"
                      :class="['input', {'is-large': true}]"
                      type="text"
                      v-model="term"
                      :placeholder="placeholder"
                      @blur="() => {
                        if (!this.term || !this.term.trim().length) {
                          this.$emit('on-updated', null)
                        }
                      }"
                    >
                  </div>
                  <div class="control">
                    <button type="submit" :class="['button is-purple', {'is-large': true}, {'is-loading': busy}]">
                      <span class="icon"><i class="fas fa-search"></i></span>
                    </button>
                  </div>
                </div>
            </fieldset>
        </form>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'search-filter',
  props: ['HTMLId','PageId', 'placeholder'],
  computed: {
    gridSize() {
      return 6
    },
    gridOffset() {
      return Math.round((12 - this.gridSize) * 0.5)
    }
  },
  emits: [
    'on-loading',
    'on-loaded'
  ],
  data() {
    return {
      term: null,
      busy: false,
    }
  },
  methods: {
    doSubmit() {
      if (this.busy) {
        return
      }

      if (!this.term || !this.term.trim().length) {
        this.$emit('on-loaded')
        this.$emit('on-updated', null)
        return
      }

      this.busy = true
      this.$emit('on-loading')
      const data = new FormData()
      data.append('term', this.term)
      data.append('page_id', this.PageId)
      axios.post(
        `api/v/1/in-block-filter/${this.HTMLId}/filter`,
        data
      ).then(resp => {
        this.$emit('on-updated', resp.data)
      }).finally(() => {
        this.busy = false
        this.$emit('on-loaded')
      })
    }
  }
}
</script>
<style lang="scss" scoped>
.search-filter-holder {
  margin-bottom: 24px;
  @media (max-width: 767px) {
    margin-bottom: 0;
  }

  .columns.is-mobile {
    > .column {
      @media (max-width: 767px) {
        width: 100% !important;
        margin-left: 0 !important;
      }
    }
  }

  .form {
    .field.has-addons {
      .control.is-fullwidth {
        width: 100%;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/blocks/modules/search/SearchFilter.vue